import React from 'react';

const PlatformSpinner = ({ 
  size = 'medium',
  color = 'primary',
  className = '',
  style = {},
  ...props 
}) => {
  // Build CSS class name for ALL platforms using token-based classes
  const getClassName = () => {
    const baseClass = 'spinner';
    const sizeClass = size !== 'medium' ? `size-${size}` : '';
    const colorClass = color !== 'primary' ? `color-${color}` : '';
    
    return [baseClass, sizeClass, colorClass, className]
      .filter(Boolean)
      .join(' ');
  };

  // Minimal inline styles for ALL platforms
  const getInlineStyles = () => {
    const styles = {};
    
    // Only add styles that CANNOT be handled by CSS
    return { ...styles, ...style };
  };

  return (
    <div 
      className={getClassName()}
      style={getInlineStyles()}
      {...props}
    />
  );
};

// Platform-specific spinner with dots
const PlatformDotsSpinner = ({ 
  size = 'medium',
  color = 'primary',
  className = '',
  style = {},
  ...props 
}) => {
  // Build CSS class name for ALL platforms using token-based classes
  const getClassName = () => {
    const baseClass = 'dots-spinner';
    const sizeClass = size !== 'medium' ? `size-${size}` : '';
    const colorClass = color !== 'primary' ? `color-${color}` : '';
    
    return [baseClass, sizeClass, colorClass, className]
      .filter(Boolean)
      .join(' ');
  };

  // Minimal inline styles for ALL platforms
  const getInlineStyles = () => {
    const styles = {};
    
    // Only add styles that CANNOT be handled by CSS
    return { ...styles, ...style };
  };

  return (
    <div 
      className={getClassName()}
      style={getInlineStyles()}
      {...props}
    >
      <div className="dot dot-1" />
      <div className="dot dot-2" />
      <div className="dot dot-3" />
    </div>
  );
};

// Platform-specific skeleton loader
const PlatformSkeleton = ({ 
  width = '100%',
  height = '20px',
  variant = 'text',
  className = '',
  style = {},
  ...props 
}) => {
  // Build CSS class name for ALL platforms using token-based classes
  const getClassName = () => {
    const baseClass = 'skeleton';
    const variantClass = variant !== 'text' ? `variant-${variant}` : '';
    
    return [baseClass, variantClass, className]
      .filter(Boolean)
      .join(' ');
  };

  // Minimal inline styles for ALL platforms
  const getInlineStyles = () => {
    const styles = {
      width: width,
      height: height
    };
    
    // Only add styles that CANNOT be handled by CSS
    return { ...styles, ...style };
  };

  return (
    <div 
      className={getClassName()}
      style={getInlineStyles()}
      {...props}
    />
  );
};

export { PlatformSpinner, PlatformDotsSpinner, PlatformSkeleton };
export default PlatformSpinner;